export const timingFaster = '0.1s';
export const timingFasterMs = 100;
export const timingFast = '0.125s';
export const timingFastMs = 125;
export const timingDefault = '0.2s';
export const timingDefaultMs = 200;
export const timingSlow = '0.3s';
export const timingSlowMs = 300;
export const timingSlower = '0.4s';
export const timingSlowerMs = 400;
export const easeInOutCubic = 'cubic-bezier(0.65, 0, 0.35, 1)';
//# sourceMappingURL=timing.js.map